<section class="h-100">
  <!-- <div class="header">
    <nav class="navbar navbar-light topbar fixed-top shadow-sm">
      <div class="container p-0">
        <a class="navbar-brand" routerLink="/">
          <img    src="{{platform_logo}}" alt="{{platform_name}}" width="160" />
        </a>
        <div class="d-flex justify-align-center float-right">
          <button routerLink="/login" class="btn btn-info btn-sm mr-2" type="button">
            Join Now / Sign In
          </button>
         
        </div>
      </div>
    </nav>
  </div> -->
  <app-outer-header-navigation></app-outer-header-navigation>
  <div class="page-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 col-md-12 col-sm-12 order-2 order-md-1">
          <div class="w-100 bg-white px-3 mb-2 py-2">
            <h1 class="card-title d-flex">
              <span class="lstick"></span>
              <div class="d-flex justify-content-between flex-fill">
                {{platform_name}} Blog
                <div>
                  <div class="btn-group" role="group" aria-label="Basic example">
                    <button type="button" class="{{blogViewClassGrid}}" (click)="changeBlogView('grid')"><span class="mdi mdi-view-grid mdi-18px"></span></button>
                    <button type="button" class="{{blogViewClassList}}" (click)="changeBlogView('list')"><span class="mdi mdi-view-headline mdi-18px"></span></button>
                  </div>
                </div>
              </div>
            </h1>
            <div class="d-flex align-items-center">
              <a href="javascript:void(0);" routerLink="/login"><span class="mdi mdi-arrow-left mdi-24px"></span></a>
              <div class="search shadow-sm ml-3 flex-fill position-relative">
                <input type="text" name="contactSearch" class="form-control border-0" placeholder="Search" (keyup)="searchBlogsTitle($event)" />
                <span class="mdi mdi-magnify mdi-2x"></span>
              </div>
            </div>
          </div>
          <!-- Showing the blogs list(D) -->
          <span id="moveTop">
            <div *ngIf="blogDetailsArr.length > 0">

              <!-- Blog grid view (D) -->
              <div *ngIf="blogView=='grid'" class="row">
                <div *ngFor="let blogdetails of blogDetailsArr; let i = index;" class="col-sm-6" [ngClass]="{'pr-sm-1': i % 2 === 0, 'pl-sm-1': i % 2 !== 0}">
                  <div class="card blogHeading">
                    <div class="card-body pb-0">
                      <div class="w-100">
                        <a href="javascript:void(0);" [routerLink]="['/blog', blogdetails.blog_title_url]">
                         
                          <h1 class="card-title mb-0 title-line-number">{{blogdetails.blog_title}}</h1>
                        </a>
                        <h2 class="mb-1 fs-18 text-info">
                          <span class="blog-cat">Category</span> - <span class="blog-cat-name" (click)="filterByCategory(blogdetails.category_id,blogdetails.category_name)">{{blogdetails.category_name}}</span>
                        </h2>
                        <p class="mb-2 font-bold d-flex">
                          Posted on {{blogdetails.posted_time}} By
                          <a class="truncateTxt" href="javascript:void(0);">{{blogdetails.name}}</a>
                        </p>
                        <div class="post-thumb mb-2">
                          <div *ngIf="blogdetails.blog_media && blogdetails.blog_media.length>0">
                            <span *ngIf="blogdetails.blog_media && blogdetails.blog_media[0].media_mime_type.includes('image/')">
                              <img    src="{{blogdetails.blog_media[0].media_path}}" class="img-fluid image-height" alt="Blog" />
                            </span>
                          </div>
                        </div>
                        <div class="post-thumb mb-2">
                          <div *ngIf="blogdetails.blog_media && blogdetails.blog_media.length>0">
                            <span *ngIf="blogdetails.blog_media && blogdetails.blog_media[0].media_mime_type.includes('video/')">
                              <video *ngIf="blogdetails.blog_media[0].thumb_media_path && blogdetails.blog_media[0].thumb_media_path !=''" poster="{{blogdetails.blog_media[0].thumb_media_path}}" [muted]="true" src="{{blogdetails.blog_media[0].media_path}}" preload="metadata" controls="controls" class="video-fluid image-height" alt="Blog" loop (mouseout)='pauseVideo($event)' type="video/mp4" controlsList="nodownload">
                                <track label="English" kind="captions" srclang="en" src="" default>
                              </video>
                              <video *ngIf="blogdetails.blog_media[0].thumb_media_path =='' || blogdetails.blog_media[0].thumb_media_path==null" [muted]="true" src="{{blogdetails.blog_media[0].media_path}}" preload="metadata" controls="controls" class="video-fluid image-height" alt="Blog" loop (mouseout)='pauseVideo($event)' type="video/mp4" controlsList="nodownload">
                                <track label="English" kind="captions" srclang="en" src="" default>
                              </video>
                            </span>
                          </div>
                        </div>
                        <div class="w-100">
                          <p class="truncate_blogDetails desc-line-number" [innerHTML]='blogdetails.seo_blog_content'></p>
                        </div>
                        <div class="card-footer bg-white mt-3 ">

                          <div class="btn-group" dropdown [dropup]="isDropup">
                            <a href="javascript:void(0);" id="button-dropup" dropdownToggle class="share_hover dropdown-toggle" aria-controls="dropdown-basic" placement="top" ngbTooltip="Share">
                                <img alt="loading..."    src="{{share_icon}}" class="img-fluid" alt="..." width="35">
                            </a>
                            <ul id="dropdown-dropup" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-dropup">
                                <li class="light-blue" role="menuitem">
                                    <div (click)="postUrlCopy(blogdetails);">
                                        <a class="dropdown-item" href="javascript:void(0);">Copy Link To Blog</a>
                                        <a href="javascript:void(0);"><small class="d-block text-left mb-2">Click
                                                here to copy blog link</small></a>
                                    </div>
                                </li>
                            </ul>
                          </div>
                          <!-- <a href="javascript:void(0);" (click)="openModal(loginalert)" placement="top" ngbTooltip="Share" class="share_hover">
                            <img    src="{{share_icon}}" class="img-fluid" alt="..." width="25" >
                          </a> -->
                          <div class="float-right mb-2">
                            <a href="javascript:void(0);" [routerLink]="['/blog', blogdetails.blog_title_url]" class="btn btn-info" placement="bottom">Read More</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Blog List view (D) -->
              <div *ngIf="blogView=='list'">
                <div class="sticky">
                  <div class="card">
                    <div class="card-body">
                      <h4 *ngIf="blog_category_name!=''" class="mb-2 fs-18 text-dark">Category - {{blog_category_name}}
                      </h4>
                      <div class="comment-widgets mb-0">
                        <ul class="list-unstyled seperater mb-0">
                          <li *ngFor="let blogdetails of blogDetailsArr">

                            <div class="d-flex">
                              <span class="pr-2" *ngIf="blogdetails.blog_media && blogdetails.blog_media.length>0 && blogdetails.blog_media[0].media_mime_type.includes('image/')">
                                <img    src="{{blogdetails.blog_media[0].media_path}}" class="img-fluid mt-1" width="60" alt="Blog" />
                              </span>
                              <span class="pr-2" *ngIf="blogdetails.blog_media && blogdetails.blog_media.length==0">
                                <img    src="{{platform_logo}}" alt="{{platform_name}}" class="img-fluid mt-1 bg-dark p-2" width="60" alt="Blog">
                              </span>
                              <!-- Shubham Start -->
                              <span *ngIf="blogdetails.blog_media && blogdetails.blog_media.length >0 && blogdetails.blog_media[0].media_mime_type.includes('video/')" class="pr-2">
                                <img    *ngIf="blogdetails.blog_media[0].thumb_media_path && blogdetails.blog_media[0].thumb_media_path !=''" src="{{blogdetails.blog_media[0].thumb_media_path}}" class="img-fluid mt-1" alt="Blog" width="60">
                                <video *ngIf="blogdetails.blog_media[0].thumb_media_path =='' || blogdetails.blog_media[0].thumb_media_path==null" width="60" [muted]="true" src="{{blogdetails.blog_media[0].media_path}}" preload="metadata" class="video-fluid mt-1 vw-60" alt="Blog" type="video/mp4">
                                  <track label="English" kind="captions" srclang="en" src="" default>
                                </video>
                              </span>
                              <!-- Shubham End -->
                              <a href="javascript:void(0);" [routerLink]="['/blog', blogdetails.blog_title_url]" class="flex-fill">
                                <h5 class="mb-1 text-info truncate_blog_title">{{blogdetails.blog_title}} </h5>
                                <p class="mb-2 d-flex turncate_blogdetail ">Posted on {{blogdetails.posted_time}} By
                                  {{blogdetails.name}}</p>
                              </a>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div *ngIf="blogListLoader" class="card list-unstyled notMes">
              <div class="card list-unstyled notMes" *ngFor="let e of [].constructor(3)">
                <div class="card-body text-center">
                  <div class="d-flex align-items-start px-2 mt-2">
                    <div class="w-75 ml-2">
                      <h5 class="mt-0 d-flex align-items-start w-100 mb-4">
                        <span class="flex-fill animated-background-name first-loader-name-news loader-message m-0">
                          <div class="background-masker btn-divide-left"></div>
                        </span>
                      </h5>
                      <h5 class="mt-0 d-flex align-items-start w-75">
                        <span class="flex-fill animated-background-name first-loader-name-news m-0">
                          <div class="background-masker btn-divide-left"></div>
                        </span>
                      </h5>
                      <h5 class="mt-0 d-flex align-items-start w-75">
                        <span class="flex-fill animated-background-name first-loader-name-news m-0">
                          <div class="background-masker btn-divide-left"></div>
                        </span>
                      </h5>
                      <h5 class="mt-0 d-flex align-items-start w-50">
                        <span class="flex-fill animated-background-name first-loader-name-news m-0">
                          <div class="background-masker btn-divide-left"></div>
                        </span>
                      </h5>
                    </div>
                  </div>
                
                </div>
              </div>
             
            </div>
            <div *ngIf="blogDetailsArr.length == 0 && !blogListLoader" class="card list-unstyled notMes">
              <div class="card-body text-center">
                <h4>
                  <strong>Welcome to {{platform_name}}!</strong>
                </h4>
                <p>No Blogs to Show for now.</p>
              </div>
            </div>

          </span>

          <div class="text-center position-relative" *ngIf="showMoreUserList && !blogListLoader">
            <a href="javascript:void(0);" (click)="showMoreUserListByName(nextPage)" class="read-more" placement="top">
              <span class="mdi mdi-chevron-double-down">Show More</span>
            </a>
          </div>


        </div>
        <div class="col-lg-4 col-md-12 col-sm-12 order-1 order-sm-2">
          <!-- desktop view start -->
          <div class="card">
            <div class="d-none d-sm-block">
              <div class="card-header bg-dark-blue rounded-top fs-14">
                Most Popular Blogs
              </div>
              <div class="card-body" *ngIf="mostViewedBlogArr.length > 0">
               
                <div class="comment-widgets mb-0">
                  <ul class="list-unstyled seperater mb-0">
                    <li class="text-info truncate_blog_tilte" *ngIf="mostViewedBlogArr.length == 0 && !blogLoader">No Blogs
                      Found</li>
                    <li class="text-info truncate_blog_title cursor-pointer" *ngFor="let blogdetails of mostViewedBlogArr" [routerLink]="['/blog', blogdetails.blog_title_url]">
                      <a class="text-dark" href="javascript:void(0);">{{blogdetails.blog_title}}</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card-body text-center" *ngIf="blogLoader">
                <h5 class="mt-0 d-flex align-items-start">
                  <span class="flex-fill animated-background-name first-loader-name-news m-0">
                    <div class="background-masker btn-divide-left"></div>
                  </span>
                </h5>
                <h5 class="mt-0 d-flex align-items-start">
                  <span class="flex-fill animated-background-name first-loader-name-news m-0">
                    <div class="background-masker btn-divide-left"></div>
                  </span>
                </h5>
                <h5 class="mt-0 d-flex align-items-start">
                  <span class="flex-fill animated-background-name first-loader-name-news m-0">
                    <div class="background-masker btn-divide-left"></div>
                  </span>
                </h5>
               
              </div>
            </div>
          </div>
          <div class="sticky">
            <div class="card">
              <div class="d-none d-sm-block">
                <div class="card-header bg-dark-blue  rounded-top fs-14">
                  Categories
                </div>
                <div class="card-body" *ngIf="categoryList.length > 0">
                  <ul class="list-unstyled seperater blog-list mb-0">
                    <li class="text-info" *ngFor="let category of categoryList" [ngClass]="{ active: activeTab == category.id  , highlight: category_id == category.id }">
                      <a href="javascript:void(0);" (click)="filterByCategory(category.id,category.category_name)">
                        <!-- <div class="d-flex py-1"> -->
                        <div class="py-1">
                          {{category.category_name}} <strong *ngIf="category.category_count > 0" class='ml-1'>({{category.category_count}})</strong>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="card-body text-center" *ngIf="categoryLoader">
                  <h5 class="mt-0 d-flex align-items-start">
                    <span class="flex-fill animated-background-name first-loader-name-news m-0">
                      <div class="background-masker btn-divide-left"></div>
                    </span>
                  </h5>
                  <h5 class="mt-0 d-flex align-items-start">
                    <span class="flex-fill animated-background-name first-loader-name-news m-0">
                      <div class="background-masker btn-divide-left"></div>
                    </span>
                  </h5>
                  <h5 class="mt-0 d-flex align-items-start">
                    <span class="flex-fill animated-background-name first-loader-name-news m-0">
                      <div class="background-masker btn-divide-left"></div>
                    </span>
                  </h5>
                 
                </div>
              </div>
            </div>
          </div>
          <!-- desktop view end -->

          <!-- mobile view start -->
          <div class="d-block d-sm-none acc-bg">
            <div class="card mb-1">
              <ngb-accordion [closeOthers]="true">
                <ngb-panel id="static-1">
                  <ng-template ngbPanelTitle>
                    <div class="bg-dark-blue  rounded-top fs-14 d-flex justify-content-between">
                      <span>Most Popular Blogs</span>
                      <span><img    class="menu-down" src="assets/icons/menu-down.svg" alt="" width="20"></span>
                    </div>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="card-body p-0" *ngIf="mostViewedBlogArr.length > 0">
                     
                      <div class="comment-widgets mb-0">
                        <ul class="list-unstyled seperater mb-0">
                          <li class="text-info truncate_blog_tilte" *ngIf="mostViewedBlogArr.length == 0 && !blogLoader">No Blogs
                            Found</li>
                          <li class="text-info truncate_blog_title cursor-pointer" *ngFor="let blogdetails of mostViewedBlogArr" [routerLink]="['/blog', blogdetails.blog_title_url]">
                            <a class="text-dark">{{blogdetails.blog_title}}</a>
                          
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="card-body text-center" *ngIf="blogLoader">
                      <h5 class="mt-0 d-flex align-items-start">
                        <span class="flex-fill animated-background-name first-loader-name-news m-0">
                          <div class="background-masker btn-divide-left"></div>
                        </span>
                      </h5>
                      <h5 class="mt-0 d-flex align-items-start">
                        <span class="flex-fill animated-background-name first-loader-name-news m-0">
                          <div class="background-masker btn-divide-left"></div>
                        </span>
                      </h5>
                      <h5 class="mt-0 d-flex align-items-start">
                        <span class="flex-fill animated-background-name first-loader-name-news m-0">
                          <div class="background-masker btn-divide-left"></div>
                        </span>
                      </h5>
                      
                    </div>
                  </ng-template>
                </ngb-panel>

              </ngb-accordion>
            </div>
            <div class="card">
              <ngb-accordion [closeOthers]="true">
                <ngb-panel id="static-2">
                  <ng-template ngbPanelTitle>
                    <div class="bg-dark-blue  rounded-top fs-14 d-flex justify-content-between">
                      <span>Categories</span>
                      <span><img    class="menu-down" src="assets/icons/menu-down.svg" alt="" width="20"></span>
                    </div>
                  </ng-template>
                  <ng-template ngbPanelContent>
                    <div class="card-body p-0" *ngIf="categoryList.length > 0">
                     
                      <ul class="list-unstyled seperater blog-list mb-0">
                        <li class="text-info" *ngFor="let category of categoryList" [ngClass]="{ active: activeTab == category.id  , highlight: category_id == category.id }">
                          <a href="javascript:void(0);" (click)="filterByCategory(category.id,category.category_name)">
                            <div class="d-flex py-1">
                              {{category.category_name}} <strong *ngIf="category.category_count > 0" class='ml-1'>({{category.category_count}})</strong>
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div class="card-body text-center" *ngIf="categoryLoader">
                      <h5 class="mt-0 d-flex align-items-start">
                        <span class="flex-fill animated-background-name first-loader-name-news m-0">
                          <div class="background-masker btn-divide-left"></div>
                        </span>
                      </h5>
                      <h5 class="mt-0 d-flex align-items-start">
                        <span class="flex-fill animated-background-name first-loader-name-news m-0">
                          <div class="background-masker btn-divide-left"></div>
                        </span>
                      </h5>
                      <h5 class="mt-0 d-flex align-items-start">
                        <span class="flex-fill animated-background-name first-loader-name-news m-0">
                          <div class="background-masker btn-divide-left"></div>
                        </span>
                      </h5>
                    
                    </div>
                  </ng-template>
                </ngb-panel>
              </ngb-accordion>
            </div>
          </div>

          <!-- mobile view end -->
        </div>
      </div>
    </div>
  </div>

</section>
<footer>
  <div class="container p-0">
    <div class="row">
      <div class="col-md-12">
        <ul class="list-inline mb-0">
          <li class="ml-2"><a href="javascript:void(0);" routerLink="/blog" class="p-2">Blog</a></li>
      
          <li class="ml-2"><a target="_blank" rel="noopener" href="{{help_center}}" class="p-2"  >Help Center</a></li>
          <li class="ml-2"><a href="javascript:void(0);" routerLink="/about" class="p-2">About us</a></li>
          <li class="ml-2"><a target="_blank" rel="noopener" href="{{terms_condition}}" class="p-2">Terms & Conditions</a></li>
          <li class="ml-2"><a target="_blank" rel="noopener" href="{{privacy_policy}}" class="p-2">Privacy Policy</a></li>
          <li class="ml-2"><a target="_blank" rel="noopener" href="{{site_map}}" class="p-2">Sitemap</a></li>
          <li class="ml-2"><a target="_blank" rel="noopener" href="{{news_site_map}}" class="p-2">News Sitemap</a></li>
        </ul>
      </div>
    </div>
  </div>
</footer>
<ng-template #loginalert>
  <div class="modal-header border-0">
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center">
    <img   alt="Smile" class="img-fluid mb-2" src="assets/images/smile.png" width="45" />
    <p>Please create account or login to use this features.</p>
    <a class="btn btn-info btn-sm mr-2" href="javascript:void(0);" (click)="redirectToLogin()">Login</a>
    <a href="javascript:void(0);" (click)="redirectToLogin()" class="btn btn-success btn-sm">Sign
      Up</a>
  </div>
</ng-template>